module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/up_icon-268270d80dba4564ffdc028f644916ed.svg";